export const weekDays = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

export const progressNoteTiles = [
  { label: "Active Night", value: "active_night", check: false, type: "admin" },
  { label: "Behaviour of Concern", value: "behavior_of_concern", check: false, type: "admin" },
  // { label: "Bowel opened", value: "bowel_opened", check: false, type: "admin" },
  { label: "BSL", value: "bsl", check: false, type: "admin" },
  { label: "Fluid Intake", value: "fluid_intake", check: false, type: "admin" },
  { label: "Food", value: "food", check: false, type: "admin", hide: true },
  // { label: "Further Details", value: "further_details", check: false, type: "admin" },
  // { label: "General Health", value: "general_health", check: false, type: "admin" },
  // { label: "Grooming", value: "grooming", check: false, type: "admin" },
  { label: "House keeping Task", value: "house_keeping_task", check: false, type: "admin" },
  // { label: "Incident Reported", value: "incident_reported", check: false, type: "admin" },
  { label: "Medication Given Photo", value: "medical_chart_photo", check: false, type: "admin" },
  { label: "Mental Health", value: "mental_health", check: false, type: "admin" },
  { label: "Mobility", value: "mobility", check: false, type: "admin" },
  { label: "Mood", value: "mood", check: false, type: "admin" },
  { label: "Outing", value: "outing", check: false, type: "admin" },
  { label: "Participant Data Submission", value: "participant_data_submission", check: false, type: "admin" },
  // { label: "Participant goals for the day", value: "participant_goals_for_the_day", check: false, type: "admin" },
  { label: "Pick Up & Drop Time", value: "pickup_and_drop_time", check: false, type: "admin" },
  // { label: "Prn Medication Taken", value: "prn_medication_taken", check: false, type: "admin" },
  { label: "Recreational Activities", value: "recreational_activities", check: false, type: "admin" },
  // { label: "Regular Medication Taken", value: "regular_medication_taken", check: false, type: "admin" },
  { label: "Risk Identified", value: "risk_identified", check: false, type: "admin" },
  { label: "Shower", value: "shower", check: false, type: "admin" },
  { label: "Bowel Chart", value: "toileting", check: false, type: "admin" },
  { label: "Vehicle Details", value: "vehicle_travel", check: false, type: "admin" },
  { label: "Food Chart", value: "food_chart", check: false, type: "admin" },
];

// for repeat feature
export const dates = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];

export const onTheSecondValue = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "weekday"];

export const onTheFirstValue = ["first", "second", "third", "fourth", "last"];

export const uomOptions = [
  { label: "Hour", value: "H" },
  { label: "KM", value: "KM" },
  { label: "Each", value: "E" },
  { label: "Day", value: "D" },
  { label: "Week", value: "W" },
  { label: "Monthly", value: "M" },
  { label: "Annual", value: "A" },
];

export const fullDateFormat = "YYYY-MM-DD HH:mm:ss";

export const fullDateFormatWSec = "YYYY-MM-DD HH:mm";

export const fullDate12hFormat = "YYYY-MM-DD LT";

export const dateFormat = "YYYY-MM-DD";

// export const namedMonthDate = "DD MMM, YYYY";
export const namedMonthDate = "DD-MM-YYYY";

// export const namedMonthDateTime = "DD MMM, YYYY LT";
export const namedMonthDateTime = "DD-MM-YYYY LT";
export const fullDate24H = "DD-MM-YYYY HH:mm";

export const modernDateFormat = "DD MMM, YY LT";

export const timeFormat = "HH:mm:ss";

export const timeFormatHour = "HH:mm";

export const lineBreak = {
  whiteSpace: "-moz-pre-wrap",
  whiteSpace: "pre-wrap",
};

// export const getInitialTiming = state => {
//     if (!me()) return "";
//     if (state) {
//         return me().role === ROLES.ACCOUNTANT ? moment().subtract(15, "days").format(dateFormat) : moment().format(dateFormat)
//     } else {
//         return me().role === ROLES.ACCOUNTANT ? moment().format(dateFormat) : moment().add(15, "days").format(dateFormat)
//     }
// }
